import { createContext, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PageTrackerContext = createContext<{ lastPagePath: string | null }>({
	lastPagePath: null,
});

export const PageTrackerProvider = ({ children }: any) => {
	const location = useLocation();
	const prevPath = useRef<string | null>(null);
	const lastDistinctPage = useRef<string | null>(null);

	useEffect(() => {
		const pathWithoutQuery = location.pathname;
		if (prevPath.current && prevPath.current !== pathWithoutQuery) {
			lastDistinctPage.current = prevPath.current;
		}
		prevPath.current = pathWithoutQuery;
	}, [location.pathname]);

	return (
		<PageTrackerContext.Provider
			value={{ lastPagePath: lastDistinctPage.current }}
		>
			{children}
		</PageTrackerContext.Provider>
	);
};

export const useLastPagePath = () => useContext(PageTrackerContext);
